import LanguageLocales from '@helsenorge/core-utils/constants/languages';
import resources from '../resources/HN.Core.Framework.NPM.JS.nb-NO.json';
const LanguageNames = {
    [LanguageLocales.NORWEGIAN]: resources.language_norwegian,
    [LanguageLocales.ENGLISH]: resources.language_english,
    [LanguageLocales.SAMI_NORTHERN]: resources.language_sami,
    [LanguageLocales.NORWEGIAN_NYNORSK]: resources.language_nynorsk,
    [LanguageLocales.LITHUANIAN]: resources.language_lithuanian,
    [LanguageLocales.POLISH]: resources.language_polish,
    [LanguageLocales.RUSSIAN]: resources.language_russian,
    [LanguageLocales.ROMANIAN]: resources.language_romanian,
};
/**
 * Used to handle a situation where both bokmål and nynorsk are available, in which
 * Bokmål and Nynorsk should appear in the languagepicker, and not Norsk and Nynorsk.
 */
export const BokmaalLanguageName = resources.language_bokmaal;
export default LanguageNames;
